import { PROD_ENV } from "./components/map/GPX/Resources";

export const environnement = process.env.NODE_ENV;
const DEFAULT_PRODUCTION_API_URL = "https://back.roadmaker.fr";
let apiUrl;
let stripePublicKey;

const getProductionApiUrl = () => {
  const configuredApiUrl =
    process.env.REACT_APP_API_URL_PROD || process.env.REACT_APP_API_URL;

  if (!configuredApiUrl || configuredApiUrl.startsWith("/")) {
    return DEFAULT_PRODUCTION_API_URL;
  }

  return configuredApiUrl;
};

if (process.env.NODE_ENV === PROD_ENV) {
  apiUrl = getProductionApiUrl();
} else {
  apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";
}
// Aucun compte Stripe actif : sans clé, Stripe n'est pas chargé.
stripePublicKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || null;

// SÉCURITÉ : la clé Stripe SECRÈTE a été retirée du navigateur.
// Les opérations Stripe privilégiées (customers, paymentMethods,
// paymentIntents) seront réimplémentées côté backend avec un nouveau
// compte Stripe et des routes authentifiées. Voir le plan de migration.

export { apiUrl, stripePublicKey };
